import { render, staticRenderFns } from "./study-textbook.vue?vue&type=template&id=44f4e2e8&scoped=true&"
import script from "./study-textbook.vue?vue&type=script&lang=ts&"
export * from "./study-textbook.vue?vue&type=script&lang=ts&"
import style0 from "./study-textbook.vue?vue&type=style&index=0&id=44f4e2e8&scoped=true&lang=scss&"
import style1 from "./study-textbook.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f4e2e8",
  null
  
)

export default component.exports